<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg10 offset-lg1>
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <v-flex xs12 sm8 offset-sm2>
            <v-layout row wrap>
              <v-flex xs10 sm6 offset-xs1 offset-sm0>
                <v-select
                  v-bind:items="schools"
                  item-text="name"
                  item-value="id"
                  v-model="schoolId"
                  :label="$t('questionnaires.new.SCHOOL_SELECT')"
                  autocomplete
                  required
                  v-show="this.$auth.check('EXPERT')"
                >
                  <template slot="selection" slot-scope="data">{{ data.item.name }}</template>
                  <template slot="item" slot-scope="data">{{ data.item.name }}</template>
                </v-select>
              </v-flex>
              <v-flex xs10 sm6 offset-xs1 offset-sm0>
              <v-select
                v-bind:items="teachers"
                item-text="name"
                item-value="id"
                v-model="teacherId"
                :label="$t('questionnaires.new.TEACHER_SELECT')"
                :disabled="!canSelectTeacher"
                required
                v-show="this.$auth.check('EXPERT')"
              >
                <template slot="selection" slot-scope="data">

                  <v-avatar>
                    <v-icon>person</v-icon>
                  </v-avatar>
                  {{ data.item.surname1 + ' ' + data.item.surname2 + ', ' + data.item.name}}

                </template>

                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-avatar>
                      <v-icon>person</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.surname1 + ' ' + data.item.surname2 + ', ' + data.item.name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.username"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>

              </v-select>
            </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2>
            <v-btn icon class="primary" v-show="this.$auth.check('EXPERT')" @click.native="getCSV"><v-icon>cloud_download</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-tabs
          v-model="activeChart"
          color="primary"
          dark
          slider-color="yellow"
          fixed-tabs
        >
          <v-tab
            key="1"
            ripple
          >
            Puntuació i contrast
          </v-tab>
          <v-tab
            key="2"
            ripple
          >
            Autoavaluacions
          </v-tab>
          <v-tab
            key="3"
            ripple
          >
            Percentatge resultats
          </v-tab>
          <v-tab
            key="4"
            ripple
          >
            Taula
          </v-tab>
          <v-tab-item
          key="1"
          >
            <v-card flat>
              <v-flex xs12>
                <line-chart :chart-data="dataObject" :options="optionsObject" :width="400" :height="200"></line-chart>
              </v-flex>
            </v-card>
          </v-tab-item>
          <v-tab-item
            key="2"
          >
            <v-card flat>
              <v-flex xs12 sm8 offset-sm2>
                <bar-chart :chart-data="barDataObject" :options="barOptionsObject"></bar-chart>
              </v-flex>
            </v-card>
          </v-tab-item>
          <v-tab-item
            key="3"
          >
            <v-card flat>
              <v-flex xs12>
                <questionnaire-evolution :teacherId="teacherId"></questionnaire-evolution>
              </v-flex>
            </v-card>
          </v-tab-item>
          <v-tab-item
            key="4"
          >
            <v-card flat>
              <v-flex xs12 sm8 offset-sm2>
                <v-data-table
                  :headers="tableHeaders"
                  :items="summaryTable"
                  hide-actions
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-right">{{ props.item.date }}</td>
                    <td class="text-xs-right">{{ props.item.evaluation.exist ? props.item.evaluation.score + ' / ' + props.item.evaluation.items : ' -- ' }}</td>
                    <td class="text-xs-right">{{ props.item.selfEvaluation.score + ' / ' + props.item.selfEvaluation.items }}</td>
                    <td class="text-xs-right">{{ props.item.evaluation.exist ? props.item.difference : ' -- '  }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </v-flex>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Home' })"><v-icon>arrow_back</v-icon></v-btn>
    <loading v-model="loading" :message="$t('common.LOADING')"></loading>
  </v-layout>
</template>

<script>
  import {ResultsResource} from '../../api/results'
  import LineChart from './LineChart'
  import ScatterChart from './ScatterChart'
  import {SchoolResource} from '../../api/school'
  import moment from 'moment'
  import Loading from '@/components/common/Loading'
  import BarChart from './BarChart'
  import QuestionnaireEvolution from './QuestionnaireEvolution'
  export default {
    name: 'charts',
    components: {
      QuestionnaireEvolution,
      BarChart,
      Loading,
      'line-chart': LineChart,
      'scatter-chart': ScatterChart,
      'bar-chart': BarChart
    },
    data () {
      return {
        dataObject: null,
        barDataObject: null,
        barOptionsObject: {
          title: {
            display: true,
            lineHeight: 1,
            text: 'Puntuacions relatives d\'autoavaluacions'
          },
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Data de l\'autoavaluació'
              }
            }],
            yAxes: [{
              ticks: {
                max: 1,
                min: 0,
                stepSize: 0.1
              },
              scaleLabel: {
                display: true,
                labelString: 'Puntuació relativa'
              }
            }]
          }
        },
        xAxesLabels: [],
        optionsObject: {
          title: {
            display: true,
            lineHeight: 1,
            text: 'Evolució de la puntuació de la mestra'
          },
          scales: {
            xAxes: [{
              id: 'x-axis-1',
              type: 'linear',
              position: 'bottom',
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Número de qüestionari'
              }
            }],
            yAxes: [{
              stacked: false,
              ticks: {
                max: 60,
                min: 0,
                stepSize: 5,
                beginAtZero: true
              },
              scaleLabel: {
                display: true,
                labelString: 'Puntuació absoluta'
              }
            }]
          }
        },
        summaryTable: [],
        tableHeaders: [
          { text: this.$t('headers.statistics.DATE'), align: 'right', sortable: false, value: 'date' },
          { text: this.$t('headers.statistics.ASSESSMENT'), align: 'right', sortable: false, value: 'eval' },
          { text: this.$t('headers.statistics.SELFASSESSMENT'), align: 'right', sortable: false, value: 'aval' },
          { text: this.$t('headers.statistics.DIFFERENCE'), align: 'right', sortable: false, value: 'diff' }
        ],
        schoolId: null,
        teacherId: null,
        schools: [],
        teachers: [],
        teachersLoaded: false,
        loading: false,
        currentTeacher: {}
      }
    },
    watch: {
      'schoolId': function () {
        if (this.schoolId !== '') {
          this.loading = true
          this.teachersLoaded = false
          this.teacherId = null
          SchoolResource().getTeachers({id: this.schoolId}).then(
            response => {
              this.teachers = response.data
              this.teachersLoaded = true
              this.loading = false
            },
            response => {
              console.log('error in teachers endpoint')
            }
          )
        }
      },
      'teacherId': function () {
        this.loading = true
        this.currentTeacher = this.getItemById(this.teachers, this.teacherId)
        this.getResultsOfTeacher(this.teacherId)
      }
    },
    mounted () {
      SchoolResource().get().then(
        response => {
          this.schools = response.data
        },
        response => {
          console.log('error in schools endpoint')
        }
      )
    },
    created () {
      // this.dataObject = this.getResultsOfTeacher(6)
      // this.setDataObject(this.dataObject)
    },
    methods: {
      getCSV: async function () {
        this.loading = true
        let response = await this.$http.get('export/questionnaires', {responseType: 'blob'})
        let blob = new Blob([response.data], {type: response.headers.get('content-type')})
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'data.xlsx'
        link.click()
        this.loading = false
      },
      getResultsOfTeacher: function (id) {
        ResultsResource().get({idTeacher: id}).then(response => {
          console.log(response.body)
          var teachersQuests = []
          var contrastQuests = []
          var teachersScore = []
          var contrastScore = []
          var teachersRelativeScore = []
          var summaryTable = []
          var questCounter = 0
          var firstContrastCounted = false
          for (var key in response.body) {
            var quest = response.body[key]
            if (quest.contrast === true) {
              contrastQuests.push(quest)

              if (!firstContrastCounted) {
                contrastScore.push({
                  x: questCounter,
                  y: quest.score
                })
                questCounter++
                firstContrastCounted = true
              } else {
                contrastScore.push({
                  x: questCounter - 1,
                  y: quest.score
                })
              }
            } else {
              teachersQuests.push(quest)
              teachersScore.push({
                x: questCounter,
                y: quest.score
              })
              questCounter++
              teachersRelativeScore.push(Math.round((quest.score / (quest.items * 2)) * 100) / 100)
            }
          }
          // console.log(questCounter)
          // console.log(teachersScore)
          // console.log(contrastScore)
          var id21 = Math.floor(Math.random() * 100)
          var id22 = Math.floor(Math.random() * 100)
          var id23 = Math.floor(Math.random() * 100)
          var seed = (id21 % 16).toString(16)
          var seed3 = (id22 % 16).toString(16)
          var seed5 = (id23 % 16).toString(16)
          var pointBgColor = '#' + seed + 'c' + seed3 + 'c' + seed5 + 'c'
          var pointBorderColor = '#' + seed + 0 + seed3 + 0 + seed5 + 0
          var borderColor = '#' + seed + 5 + seed3 + 5 + seed5 + 5

          var datasetLineTeacher = {
            label: this.currentTeacher.name,
            data: teachersScore,
            spanGaps: false,
            fill: false,
            xAxisID: 'x-axis-1',
            pointBackgroundColor: pointBgColor,
            borderColor: borderColor,
            radius: 5,
            pointHoverRadius: 7
          }
          var datasetLineContrast = {
            label: 'Experta',
            data: contrastScore,
            spanGaps: false,
            fill: false,
            xAxisID: 'x-axis-1',
            pointBackgroundColor: pointBgColor,
            pointBorderColor: pointBorderColor,
            radius: 5,
            pointHoverRadius: 7,
            pointStyle: 'triangle'
          }
          var len = datasetLineTeacher.data.length > datasetLineContrast.data.length ? datasetLineTeacher.data.length : datasetLineContrast.data.length
          var labels = ['']
          // console.log(teachersQuests)
          // console.log(contrastQuests)
          for (var i = 1; i < len; i++) {
            labels.push(moment(new Date(teachersQuests[i].creationDate)).format('DD-MM-YYYY'))
          }
          this.xAxesLabels = labels
          var resultsObject = {
            labels: labels,
            datasets: [datasetLineTeacher, datasetLineContrast]
          }
          var datasetBarRelative = {
            label: 'Teacher ' + id,
            data: teachersRelativeScore,
            backgroundColor: pointBgColor,
            borderColor: borderColor
          }
          // console.log(labels)
          var barResultsObject = {
            labels: labels,
            datasets: [datasetBarRelative]
          }
          teachersQuests.forEach(q => {
            var row = {
              id: q.questionnaireId,
              date: moment(new Date(q.creationDate)).format('DD-MM-YYYY'),
              evaluation: {
                exist: false,
                score: 0,
                items: 30
              },
              selfEvaluation: {
                score: q.score,
                items: q.items
              },
              difference: null
            }
            summaryTable.push(row)
          })
          contrastQuests.forEach(q => {
            var index = summaryTable.findIndex(el => el.id === q.idContrast)
            console.log(index)
            if (index >= 0) {
              summaryTable[index].evaluation.exist = true
              summaryTable[index].evaluation.score = q.score
              summaryTable[index].difference = summaryTable[index].selfEvaluation.score - q.score
            } else {
              var row = {
                id: q.idContrast,
                date: moment(new Date(q.creationDate)).format('DD-MM-YYYY'),
                evaluation: {
                  exist: true,
                  score: q.score,
                  items: 30
                },
                selfEvaluation: {
                  score: '--',
                  items: '--'
                },
                difference: '--'
              }
              summaryTable.push(row)
            }
          })
          this.summaryTable = summaryTable
          console.log(this.summaryTable)
          this.dataObject = resultsObject
          this.barDataObject = barResultsObject
          this.loading = false
        }, response => {
          this.loading = false
          return false
        })
      },
      setDataObject: function (data) {
        this.dataObject = data
      },
      getItemById: function (collection, id) {
        return this._.find(collection, function (i) {
          return i.id === id
        })
      }
    },
    computed: {
      schoolSelected: function () {
        return this.schoolId !== '' && this.schoolId !== null
      },
      canSelectTeacher: function () {
        return this.schoolSelected && this.teachersLoaded
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/results/Charts.vue